module.exports = __webpack_public_path__ + "static/media/ios-bulb.7a7f90f3.svg";